import React from 'react';
import {
    Box, Grid, Skeleton,
} from '@mui/material';
import { StyledBox } from './FormSection.styles';

const FormSectionSkeleton = () => (
    <StyledBox maxWidth="xl">
        <Box className="FSWrapper">
            <Skeleton variant="text" width="40%" height={32} />
            <Skeleton variant="rectangular" width="100%" height={60} sx={{ my: 2 }} />
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
            </Grid>
            <Skeleton variant="rectangular" width="100%" height={64} sx={{ my: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={120} />
            <Skeleton variant="text" width="30%" height={32} sx={{ mt: 3 }} />
            <Grid container spacing={2}>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
                <Grid item lg={6} md={6} xs={12}>
                    <Skeleton variant="rectangular" width="100%" height={64} />
                </Grid>
            </Grid>
            <Skeleton variant="rectangular" width="100%" height={64} sx={{ my: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={120} />
            <Skeleton variant="rectangular" width="100%" height={48} sx={{ mt: 2 }} />
            <Skeleton variant="rectangular" width="100%" height={48} sx={{ mt: 2 }} />
            <Skeleton variant="text" width="80px" height={48} sx={{ ml: 'auto', mt: 2 }} />
        </Box>
    </StyledBox>
);

export { FormSectionSkeleton };


